<div class="row pt-4">
    <div class="col-md-12">
        <div class="card p-3">
            <div *ngIf="carregandoEleitores == true" class="carregando">
                <div class="c-loader"></div>
            </div>
            <div class="d-flex flex-row align-items-center">
                <h5 class="class = mb-0 mr-auto">Lista de Eleitores Para Envio</h5> 
                <div class="justify-items-end">
                    <button  class="btn mr-2 btn-light ml-auto" (click)="baixarTemplate()" pTooltip="Baixar modelo de importação">
                        <i class="fas fa-file-download"></i>
                    </button>
                    <button  class="btn mr-2 btn-success ml-auto" data-toggle="modal" data-target="#modalcsv" pTooltip="Importar Lista Personalizada para Envio">
                        <i class="fas fa-file-csv"></i>
                    </button>
                    <button  class="btn btn-success" (click)="buscarEleitoresPorEleicaoId()" pTooltip="Carregar Eleitores Cadastrados na Eleição">
                        <i class="fas fa-database"></i>
                    </button>
                </div>
            </div>
            <hr>
            <div class="input-group mb-3">
                <input type="text" class="form-control" id="filtroEleitor" placeholder="Digite o login do eleitor para buscar">
                <div class="input-group-append">
                  <button class="btn btn-secondary" type="button" style="font-size:15px!important;" (click)="filtrarEleitoresPorNome()"><i class="fas fa-search"></i></button>
                </div>
                <div class="input-group-append">
                    <button class="btn btn-outline-secondary" type="button" style="font-size:15px!important;" (click)="limparFiltro()"><i class="fas fa-eraser"></i></button>
                </div>
            </div>         
            <table class="table table-bordered"> 
                
                <thead>
                    <tr>
                        <th style="width: 50%;">Login</th>
                        <th style="width: 50%;">E-mails</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let eleitor of eleitores | paginate: { itemsPerPage: contador, currentPage: paginaAtual }">
                        <td>{{eleitor.login}}</td>
                        <td>{{eleitor.email}}</td>
                    </tr>
                </tbody>
            </table>
            <!-- <pagination [page]="page" (paginationEvent)=changePage($event)></pagination> -->
            <div class="text-right" *ngIf="eleitores.length > 0">
                <pagination-controls class="ml-auto" (pageChange)="paginaAtual = $event" previousLabel="Anterior" nextLabel="Próximo"></pagination-controls>
            </div>
            <div>
                <button [disabled]="btOff" (click)="envioEleitores()" class="btn btn-success btn-custom" pTooltip="Clique para disparar os E-mails">
                    <i class="fa fa-share"></i>  Enviar
                </button>
            </div>
        </div>
    </div>
</div>

<!-- The Modal -->
<div class="modal fade" id="modalcsv"  #content>
    <app-massa-email></app-massa-email>
</div>